const UUID_REGEX =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export function normalizeUrlPath(url: string): string | undefined {
  try {
    const parsed = new URL(url);
    const path = parsed.pathname;
    if (!path || path === '/') return '/';

    return path
      .split('/')
      .map((segment) => {
        if (!segment) return segment;
        if (/^\d+$/.test(segment)) return '{id}';
        if (UUID_REGEX.test(segment))
          return segment.replace(UUID_REGEX, '{id}');
        return segment;
      })
      .join('/');
  } catch {
    return undefined;
  }
}
